import Request from "./Request";
// TODO: change it back to window.location.origin
const BASE_URL = "http://127.0.0.1:4000";

class AdminApi {
  static editRound(data) {
    return new Request("/admin/edit_round", {
      method: "POST",
      data: data,
      headers: { "content-type": "application/json" },
    });
  }

  static loadNormalizeRound() {
    return new Request("/admin/set_normalize");
  }

  static loadAppsFromQuill() {
    return new Request("/admin/load_apps_from_quill");
  }

  static loadAppsFromFeather() {
    return new Request("/admin/load_apps_from_feather");
  }

  static loadRawScore() {
    return new Request("/admin/get_raw_score_csv", {
      method: "GET",
      responseType: "blob",
      headers: {
        "Content-Type": "text/csv",
      },
    });
  }

  static loadAppResult() {
    return new Request("/admin/get_score_result_csv", {
      method: "GET", 
      responseType: "blob",
      headers: {
        "Content-Type": "text/csv",
      },
    });
  }

  static loadNewAppsFromFeather() {
    return new Request("/admin/load_new_apps_from_feather");
  }

  static removeOldAppsFromFeather() {
    return new Request("/admin/remove_old_apps_from_feather");
  }
  
  static isAdmin() {
    return new Request("/admin/is_admin");
  }

  static setRound(new_round) {
    return new Request("/admin/set_round?new_round=" + new_round);
  }

  static getRounds() {
    return new Request("/admin/get_rounds");
  }

  static activateUser(user) {
    return new Request("/admin/activate_user?user=" + user);
  }

  static deactivateUser(user) {
    return new Request("/admin/deactivate_user?user=" + user);
  }

  static confirmUser(user) {
    return new Request("/admin/confirm_user?user=" + user);
  }

  static makeAdmin(user, changeTo) {
    return new Request(
      "/admin/make_admin?user=" + user + "&change=" + changeTo
    );
  }

  static admitFreshmen() {
    return new Request("/admin/admit_freshmen");
  }

  static changeSettings(settings) {
    return new Request("/admin/change_settings", {
      method: "POST",
      data: settings,
    });
  }

  static getSettings() {
    return new Request("/admin/get_settings");
  }

  static generateScores(round_number, settings_params) {
    return new Request("/scoring/generate-scores", {
      responseType: "blob",
      params: { round_number: round_number, ...settings_params },
    });
  }
  static exportScores() {
    return new Request("/admin/export_scores", {
      responseType: "blob",
      headers: { "Cache-Control": "no-cache" },
    });
  }
  static exportApps() {
    return new Request("/admin/export_apps", {
      responseType: "blob",
      headers: { "Cache-Control": "no-cache" },
    });
  }
}

export default AdminApi;



// WEBPACK FOOTER //
// ./src/components/utils/AdminApi.js